/** Format a number in the unit a chart or KPI tile declares ("%", "days", "CAD", ...). */
export const formatMeasure = (value, unit = '') => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return value === null || value === undefined ? '' : String(value);
  }
  const text = numeric.toLocaleString(undefined, { maximumFractionDigits: 2 });
  const measure = String(unit || '').trim();
  if (!measure) return text;
  if (measure === '%') return `${text}%`;
  if (/^(cad|usd|\$)$/i.test(measure)) return `$${text}`;
  return `${text} ${measure}`;
};

export default formatMeasure;
